"use client";

import {
  Box,
  CloseButton,
  Drawer,
  Flex,
  Heading,
  IconButton,
  Portal,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { CiMenuFries } from "react-icons/ci";

import { ColorModeButton } from "@components/ui/color-mode";
import NavigationLinks from "@features/services/NavigationLinks";
import NavigationTabs from "@features/services/NavigationTabs";
import { PageNavigation } from "@features/services/PageNavigation";
import Link from "next/link";
import { BrandMarkIcon } from "vectors";
import UserAvatarMenu from "@components/core/UserAvatarMenu";
import { useBasePath } from "hooks/useBasePath";

const SidebarMenuButton = () => {
  const [open, setOpen] = useState(false);

  const onToggle = () => {
    setOpen(!open);
  };

  return (
    <Drawer.Root size="full" onOpenChange={onToggle} open={open}>
      <Drawer.Trigger asChild>
        <IconButton variant="ghost" _hover={{ bg: "sidebar.hoverButton" }}>
          <CiMenuFries />
        </IconButton>
      </Drawer.Trigger>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Header>
              <Drawer.CloseTrigger asChild pos="initial">
                <CloseButton />
              </Drawer.CloseTrigger>
            </Drawer.Header>
            <Drawer.Body>
              <PageNavigation onSelect={onToggle} />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};

const TopBar = () => {
  const basePath = useBasePath();
  const isBackOffice = basePath === "back-office";

  return (
    <Flex
      flexDirection="column"
      position="sticky"
      top={0}
      zIndex="sticky"
      bg="sidebar.background"
    >
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        px={{ base: 4, md: 6 }}
        py={2}
        alignItems="center"
      >
        <Link href={isBackOffice ? "/back-office" : "/"}>
          <Flex alignItems="center" gap={2}>
            <BrandMarkIcon color="fg" height="25px" w="auto" />
            {isBackOffice && <Heading size="sm">Back Office</Heading>}
          </Flex>
        </Link>
        <Flex flexDirection="row" gap={2} alignItems="center">
          <Box hideBelow="lg">
            <NavigationLinks />
          </Box>
        </Flex>
        <Flex flexDirection="row" gap={2} alignItems="center">
          <ColorModeButton />
          {isBackOffice ? <UserAvatarMenu /> : null}
        </Flex>
      </Flex>
      <NavigationTabs />
    </Flex>
  );
};

export default observer(TopBar);
